export default __webpack_public_path__ + "static/media/041-CT scan.c3e8621b.svg";